import DetailSheet from './DetailSheet';

export default DetailSheet;
